import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-reservations',
  storeModule.createStoreModule('real-estate-developments-reservations')
)
